// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-vowFj","operation":"operation-_Ycu8"};